/* global $ */

(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintModalToolsView = (scope.PrintModalToolsView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;

    this.$el = $("#PrintModalToolsView");

    this.$el.on("click", ".modal-background", this.hideModal.bind(this));
    this.$el.on("click", ".modal-got-it", this.hideModal.bind(this));
  });

  /**
   * Hide modal tool
   * @public
   */
  PrintModalToolsView.prototype.hideModal = function (e) {
    if (!localStorage.getItem(this.controller.currentTool)) {
      localStorage.setItem(this.controller.currentTool, "true");
    }

    // pause video
    $("." + this.controller.currentTool + " .tool-video iframe").each(
      function () {
        this.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    );

    this.$el.hide();
  };

  /**
   * Show the modal of the current tool
   * @public
   * @param {TOOLS}
   */
  PrintModalToolsView.prototype.showModal = function (forceShowModal) {
    //only test the local storage if we don't force the modal to be displayed
    if (forceShowModal == false) {
      //if we already saw the modal of that current tool we don't show it again
      if (localStorage.getItem(this.controller.currentTool)) {
        return;
      }
    }
    //hide all text about the tool in modal help
    $(".tools-text").hide();

    var youtubePlayer = function (videoId) {
      return (
        '<iframe title="youtube" width="560" height="349" src="https://www.youtube.com/embed/' +
        videoId +
        '?rel=0&enablejsapi=1" frameborder="0" allowfullscreen></iframe>'
      );
    };

    //change the title of the modal with the current use tool + show the good text base on the current tool
    switch (this.controller.currentTool) {
      case sculpteo.PrintToolsView.TOOLS.BATCH_CONTROL:
        $(".modal-tool-title").text(gettext("Review batch"));
        // the video is out of date
        $("." + this.controller.currentTool).show();
        break;
      case sculpteo.PrintToolsView.TOOLS.ORIENTATION:
        $(".modal-tool-title").text(gettext("Part Orientation"));
        $("." + this.controller.currentTool + " .tool-video").html(
          youtubePlayer("5tqq00-8N_k")
        );
        $("." + this.controller.currentTool).show();
        break;
      case sculpteo.PrintToolsView.TOOLS.HOLLOWING:
        $(".modal-tool-title").text(gettext("Hollowing"));
        $("." + this.controller.currentTool + " .tool-video").html(
          youtubePlayer("m-RjS6GdzDE")
        );
        $("." + this.controller.currentTool).show();
        break;
      case sculpteo.PrintToolsView.TOOLS.THICKENING:
        $(".modal-tool-title").text(gettext("Thickening"));
        $("." + this.controller.currentTool + " .tool-video").html(
          youtubePlayer("LAeUbNpKCK4")
        );
        $("." + this.controller.currentTool).show();
        break;
      case sculpteo.PrintToolsView.TOOLS.ANNOTATIONS:
        $(".modal-tool-title").text(gettext("Annotations"));
        $("." + this.controller.currentTool).show();
        break;
    }

    this.$el.show();
  };

  /**
   * Hide modal tool and change the tool to default view
   * @private
   */
  PrintModalToolsView.prototype.BackToDefaultView = function (e) {
    this.hideModal(e);
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };
})((window.sculpteo = window.sculpteo || {}));
